// extracted by mini-css-extract-plugin
export default {"characterBody":"CharacterBody_characterBody__5IOQw","characterSpriteContainer":"CharacterBody_characterSpriteContainer__oSVWI"};